import { IPackageListingAppBaseSettings, defaultBaseSettings } from "../../classes/package-listing-settings";

/**
 * Want to add more text? Go to custom/classes/calendar-text and add new properties there.
 */
interface IPackageListingCustomSettings{
}


let customText: IPackageListingCustomSettings = {
}

export type IPackageListingAppSettings= IPackageListingCustomSettings & IPackageListingAppBaseSettings;
export const defaultSettings: IPackageListingAppSettings= { ...defaultBaseSettings, ...customText };